import homeObjOneImg from "../../images/yellow-online_banking.svg";
import homeObjTwoImg from "../../images/blue-investing.svg";
import homeObjThreeImg from "../../images/yellow-taxes.svg";

export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Mobile Finance Tracking',
    headLine: "Track All Your Account Activity, Simply.",
    description: "From your bills to your nights out, our personalized mobile app helps you stay on track with your spending and saving. Our security experts will also alert you if we suspect fraudulent spending.",
    buttonLabel: 'Get Started',
    imgStart: false,
    img: homeObjOneImg,
    alt: "Pie-Chart",
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'discover',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: "Retirement Plans",
    headLine: 'Traditional and Roth IRAs', 
    description: "Choose a retirement plan that fits with your needs and lifestyle. Link your account to our mobile app and keep track of your retirement investments anywhere, anytime.",
    buttonLabel: 'Get Started',
    imgStart: true,
    img: homeObjTwoImg,
    alt: "Pie-Chart",
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjThree = {
    id: 'signup',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: "Finance Management",
    headLine: "From taxes to mortgages",
    description: "Speak with our round the clock expert finance managers to help guide you in making the right finance decisions. Don't get caught out by Uncle Sam or predatory loans again.",
    buttonLabel: 'Get Started',
    imgStart: false,
    img: homeObjThreeImg,
    alt: "Pie-Chart",
    dark: true,
    primary: true,
    darkText: false
};